import React from "react";
import PropTypes from "prop-types";
import { Type, DialogTitleActions } from "@ebscois/react-component-library";

import {
  StyledContributorWrapper,
  StyledDialog,
  StyledDialogTitle,
  StyledDialogScroll,
} from "./_.styled";

const ContributorsDialog = ({ isOpen, onClose, contributors }) => (
  <StyledDialog isOpen={isOpen} onRequestClose={onClose} maxWidth="md">
    <StyledDialogTitle>
      <Type element="h1" fontFamily="secondary">
        Editors & Disclosures
      </Type>
      <DialogTitleActions onRequestClose={onClose} />
    </StyledDialogTitle>
    <StyledDialogScroll>
      {contributors.map((contributor) => {
        const name = `${contributor.givenName} ${contributor.surname} ${contributor.degrees}`;

        return (
          <StyledContributorWrapper key={name}>
            <Type textTransform="uppercase" fontSize="sm">
              {contributor.label}
            </Type>
            <Type fontWeight="bold" fontSize="lg">
              {name}
            </Type>
            <Type fontSize="sm" marginTop="xs">
              <strong>Affiliations:</strong> {contributor.affiliationText}
            </Type>
            <Type fontSize="sm" marginTop="xs">
              <strong>Conflict of Interest:</strong> {contributor.conflictsText}
            </Type>
          </StyledContributorWrapper>
        );
      })}
    </StyledDialogScroll>
  </StyledDialog>
);

ContributorsDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  contributors: PropTypes.arrayOf(
    PropTypes.shape({
      affiliationText: PropTypes.string.isRequired,
      conflictsText: PropTypes.string.isRequired,
      degrees: PropTypes.string.isRequired,
      givenName: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      surname: PropTypes.string.isRequired,
    })
  ),
};

ContributorsDialog.displayName = "ContributorsDialog";
export default ContributorsDialog;
